"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Determines if the user has enabled 'do not track' in their browser.
 * There are various implementations of this depending upon browser and
 * browser version.
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Navigator/doNotTrack
 */
function isDoNotTrackEnabled() {
    if (typeof window !== 'undefined') {
        return window.doNotTrack === '1' || navigator.doNotTrack === '1';
    }
    return false;
}
exports.isDoNotTrackEnabled = isDoNotTrackEnabled;
